import { render, staticRenderFns } from "./ManagePermissions.modal.vue?vue&type=template&id=2f7578f0"
import script from "./ManagePermissions.modal.vue?vue&type=script&lang=ts"
export * from "./ManagePermissions.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManagePermissions.modal.vue?vue&type=style&index=0&id=2f7578f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports